export default "__VITE_ASSET__BRxADyoH__"